<template>
  <div>
    <div class="content-panel">
      <div class="panel-header">
        <h3 class="panel-title">{{ $t("addresse.title") }}</h3>
        <button class="btn-add-address" @click="handleAddAddress">
          {{ $t("addresse.addAddress") }}
        </button>
      </div>

      <!-- ===== 表格 ===== -->
      <div class="product-table-wrap">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-state">
          <span class="loading-spinner"></span>
          <p>{{ $t("addresse.loading") }}</p>
        </div>

        <!-- 空状态 -->
        <div v-else-if="addressList.length === 0" class="empty-state">
          <span class="empty-icon">📭</span>
          <p>{{ $t("addresse.empty") }}</p>
        </div>

        <!-- 表格 -->
        <table v-else class="product-table">
          <thead>
            <tr>
              <th>{{ $t("addresse.coin") }}</th>
              <th>{{ $t("addresse.network") }}</th>
              <th>{{ $t("addresse.address") }}</th>
              <th>{{ $t("addresse.time") }}</th>
              <th>{{ $t("addresse.action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in addressList" :key="item.id || index">
              <td>
                <span class="status-badge status-active">{{ item.name }}</span>
              </td>
              <td>{{ item.network }}</td>
              <td class="address-cell">{{ item.address }}</td>
              <td>{{ item.create_time }}</td>
              <td>
                <button class="btn-delete" @click="handleDeleteAddress(item)">
                  {{ $t("addresse.delete") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      <!-- ===== 删除确认弹窗 ===== -->
      <div
        v-if="showDeleteConfirm"
        class="modal-overlay"
        @click.self="closeDeleteConfirm"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{ $t("addresse.delete") }}</h3>
            <button class="modal-close" @click="closeDeleteConfirm">✕</button>
          </div>
          <div class="modal-body">
            <p class="confirm-text">{{ $t("addresse.deleteConfirm") }}</p>
            <p class="confirm-address" v-if="deleteTarget?.address">
              {{ deleteTarget.address }}
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn-modal-cancel" @click="closeDeleteConfirm">
              {{ $t("addresse.cancel") }}
            </button>
            <button class="btn-modal-delete" @click="confirmDeleteAddress">
              {{ $t("addresse.confirmDelete") }}
            </button>
          </div>
        </div>
      </div>

      <!-- ===== 分页 ===== -->
        <div v-if="total > 0" class="pagination-wrap">
          <div class="pagination-info">
            {{ $t("addresse.paginationInfo", { total, page, totalPages }) }}
          </div>
          <div class="pagination-buttons">
            <button
              class="page-btn"
              :disabled="page <= 1"
              @click="changePage(1)"
            >
              {{ $t("addresse.firstPage") }}
            </button>
            <button
              class="page-btn"
              :disabled="page <= 1"
              @click="changePage(page - 1)"
            >
              {{ $t("addresse.prevPage") }}
            </button>

            <button
              v-for="p in pageNumbers"
              :key="p"
              class="page-btn"
              :class="{ active: p === page }"
              @click="changePage(p)"
            >
              {{ p }}
            </button>

            <button
              class="page-btn"
              :disabled="page >= totalPages"
              @click="changePage(page + 1)"
            >
              {{ $t("addresse.nextPage") }}
            </button>
            <button
              class="page-btn"
              :disabled="page >= totalPages"
              @click="changePage(totalPages)"
            >
              {{ $t("addresse.lastPage") }}
            </button>
          </div>
          <div class="pagination-size">
            <select
              v-model="size"
              @change="handleSizeChange"
              class="size-select"
            >
              <option :value="10">{{ $t("addresse.perPage", { count: 10 }) }}</option>
              <option :value="20">{{ $t("addresse.perPage", { count: 20 }) }}</option>
              <option :value="50">{{ $t("addresse.perPage", { count: 50 }) }}</option>
              <option :value="100">{{ $t("addresse.perPage", { count: 100 }) }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddresseList",
  data() {
    return {
      // 分页参数
      page: 1,
      size: 10,
      total: 0,

      // 数据
      addressList: [],
      loading: false,

      // 删除确认弹窗
      showDeleteConfirm: false,
      deleteTarget: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.size);
    },
    pageNumbers() {
      const pages = [];
      const total = this.totalPages;
      const current = this.page;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        if (current > 3) {
          pages.push("...");
        }
        for (
          let i = Math.max(2, current - 1);
          i <= Math.min(total - 1, current + 1);
          i++
        ) {
          pages.push(i);
        }
        if (current < total - 2) {
          pages.push("...");
        }
        pages.push(total);
      }
      return pages;
    },
  },
  created() {
    this.getAddressList();
  },
  methods: {
    // ===== 获取提现地址列表 =====
    getAddressList() {
      this.loading = true;

      this.$api.userWallet
        .getWalletAddressList({
          page: this.page,
          size: this.size,
        })
        .then((res) => {
          if (res.code === 0) {
            this.addressList = res.data.data || [];
            this.total = res.data.total || 0;
            this.page = res.data.current || 1;
            this.size = res.data.pageSize || 10;
          } else {
            console.error("获取提现地址失败:", res.msg);
            this.addressList = [];
            this.total = 0;
          }
        })
        .catch((error) => {
          console.error("接口请求异常:", error);
          this.addressList = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ===== 添加地址 =====
    handleAddAddress() {
      // console.log("添加提现地址");
      this.$router.push({ name: "BindAddress" });
    },

    // ===== 删除地址 =====
    handleDeleteAddress(item) {
      this.deleteTarget = item;
      this.showDeleteConfirm = true;
    },

    closeDeleteConfirm() {
      this.showDeleteConfirm = false;
      this.deleteTarget = null;
    },

    confirmDeleteAddress() {
      const item = this.deleteTarget;
      if (!item) return;
      this.$api.userWallet
        .delWalletAddress({
          id: item.id,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: this.$t("addresse.deleteSuccess"),
              type: "success",
            });
            this.closeDeleteConfirm();
            this.getAddressList();
          } else {
            console.error("删除提现地址失败:", res.msg);
          }
        })
        .catch((error) => {
          console.error("接口请求异常:", error);
        });
    },

    // ===== 分页 =====
    changePage(page) {
      if (page < 1 || page > this.totalPages || page === this.page) return;
      this.page = page;
      this.getAddressList();
    },

    // ===== 每页条数变化 =====
    handleSizeChange() {
      this.page = 1;
      this.getAddressList();
    },
  },
};
</script>

<style scoped>
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.panel-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.btn-add-address {
  padding: 8px 20px;
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-add-address:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 180, 255, 0.3);
}

/* ===== 表格 ===== */
.product-table-wrap {
  overflow-x: auto;
}

.product-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.product-table thead th {
  text-align: left;
  padding: 12px 10px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  white-space: nowrap;
}

.product-table tbody td {
  padding: 14px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
}

.product-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

.address-cell {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  font-family: "SF Mono", "Courier New", monospace;
}

/* ===== 状态标签 ===== */
.status-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.status-active {
  background: rgba(0, 180, 255, 0.15);
  color: #4fc3ff;
}

/* ===== 删除按钮 ===== */
.btn-delete {
  padding: 4px 14px;
  background: rgba(255, 82, 82, 0.12);
  border: 1px solid rgba(255, 82, 82, 0.2);
  border-radius: 6px;
  color: #ff6b6b;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-delete:hover {
  background: rgba(255, 82, 82, 0.25);
  border-color: #ff6b6b;
}

/* ===== 删除确认弹窗 ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #141428;
  border-radius: 16px;
  width: 92%;
  max-width: 420px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.modal-body {
  padding: 20px 24px;
}

.confirm-text {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 12px;
  line-height: 1.6;
}

.confirm-address {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-family: "SF Mono", "Courier New", monospace;
  background: rgba(255, 255, 255, 0.04);
  padding: 10px 12px;
  border-radius: 8px;
  word-break: break-all;
  margin: 0;
}

.modal-footer {
  padding: 16px 24px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-modal-cancel {
  padding: 8px 24px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-modal-cancel:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.btn-modal-delete {
  padding: 8px 24px;
  background: #ff5252;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-modal-delete:hover {
  background: #ff6b6b;
  box-shadow: 0 4px 20px rgba(255, 82, 82, 0.3);
}

/* ===== 加载状态 ===== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.3);
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4fc3ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.3);
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

/* ===== 分页 ===== */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 0 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  margin-top: 16px;
  flex-wrap: wrap;
}

.pagination-info {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  white-space: nowrap;
}

.pagination-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.page-btn {
  padding: 6px 12px;
  min-width: 32px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.page-btn:hover:not(:disabled):not(.active) {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.85);
}

.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-btn.active {
  background: rgba(0, 180, 255, 0.2);
  border-color: rgba(0, 180, 255, 0.3);
  color: #4fc3ff;
}

.pagination-size {
  display: flex;
  align-items: center;
}

.size-select {
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  outline: none;
  cursor: pointer;
}

.size-select:focus {
  border-color: rgba(0, 180, 255, 0.3);
}

.size-select option {
  background: #1a1a2e;
  color: #fff;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .panel-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .product-table thead th,
  .product-table tbody td {
    padding: 10px 6px;
    font-size: 12px;
  }

  .pagination-wrap {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .pagination-info {
    font-size: 12px;
  }

  .page-btn {
    padding: 4px 10px;
    font-size: 12px;
    min-width: 28px;
  }
}

@media (max-width: 480px) {
  .product-table thead th,
  .product-table tbody td {
    padding: 8px 4px;
    font-size: 11px;
  }
}
</style>
